import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { BarChart3, CalendarRange, ClipboardList, ExternalLink, Image, KeyRound, LogOut, Sparkles, Tags } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/lib/auth";
import { api, errMsg } from "@/lib/api";

const NAV = [
  ["reservas", "Reservas", ClipboardList], ["calendario", "Calendario", CalendarRange], ["precios", "Precios y cupos", Tags],
  ["extras", "Extras cabaña", Sparkles], ["contenido", "Contenido", Image], ["reportes", "Reportes", BarChart3],
];

function PasswordDialog({ open, onOpenChange }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const save = async () => {
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Contraseña actualizada");
      onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle>Cambiar contraseña</DialogTitle></DialogHeader>
        <Input type="password" placeholder="Contraseña actual" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="current-password-input" />
        <Input type="password" placeholder="Nueva contraseña (mín. 8)" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="new-password-input" />
        <button onClick={save} className="rounded-full bg-[#5E6B52] text-white py-2.5 font-semibold" data-testid="save-password-btn">Guardar</button>
      </DialogContent>
    </Dialog>
  );
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const [pw, setPw] = useState(false);
  const link = ({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors whitespace-nowrap ${isActive ? "bg-[#5E6B52] text-white" : "text-foreground hover:bg-[#E9EFE6]"}`;
  return (
    <div className="min-h-screen bg-[#FAF7F2] lg:flex" data-testid="admin-layout">
      <aside className="lg:w-64 lg:min-h-screen lg:border-r border-border bg-[#F3EDE2]/60 lg:sticky lg:top-0 lg:self-start">
        <div className="px-5 py-5 flex items-center justify-between lg:block">
          <div>
            <p className="font-serif text-2xl">Rachel Lodge</p>
            <p className="text-xs text-muted-foreground truncate max-w-[200px]">{user?.email}</p>
          </div>
          <button onClick={logout} className="lg:hidden text-sm flex items-center gap-1" data-testid="admin-logout-mobile"><LogOut className="h-4 w-4" />Salir</button>
        </div>
        <nav className="flex lg:flex-col gap-1 px-3 pb-3 overflow-x-auto">
          {NAV.map(([to, l, Icon]) => (
            <NavLink key={to} to={`/admin/${to}`} className={link} data-testid={`admin-nav-${to}`}><Icon className="h-4 w-4" />{l}</NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex flex-col gap-1 px-3 mt-6">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2 text-sm text-muted-foreground hover:text-foreground"><ExternalLink className="h-4 w-4" />Ver sitio</a>
          <button onClick={() => setPw(true)} className="flex items-center gap-3 px-3 py-2 text-sm text-muted-foreground hover:text-foreground" data-testid="change-password-btn"><KeyRound className="h-4 w-4" />Cambiar contraseña</button>
          <button onClick={logout} className="flex items-center gap-3 px-3 py-2 text-sm text-muted-foreground hover:text-foreground" data-testid="admin-logout-btn"><LogOut className="h-4 w-4" />Cerrar sesión</button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-10">
        <Outlet />
      </main>
      <PasswordDialog open={pw} onOpenChange={setPw} />
    </div>
  );
}
